import { Dayjs } from 'dayjs';
import type { BriefingPeriod } from '../contract';

// Helpers for the spoken summaries (a day, this week, next week). Pure, so they can be tested without a screen or a speaker.

export type BriefingDays = {
    today: Dayjs;       // the real current day
    selected: Dayjs;    // the day the display is showing (today unless someone moved it)
};

// What to ask the API for: the stretch to cover, as it wants it, [start, end). A day is the one the display is showing; this
// week and next week are calendar weeks counted from today. Days and weeks start where the calendar says they do in the viewer's
// own time zone, and adding a day or a week keeps midnight across a clock change.
export function briefingRequest(period: BriefingPeriod, { today, selected }: BriefingDays, timeZone: string) {
    const start = period === 'day' ? selected.startOf('day')
        : period === 'week' ? today.startOf('week')
            : today.startOf('week').add(1, 'week');
    const end = period === 'day' ? start.add(1, 'day') : start.add(1, 'week');

    return { period, start: start.toISOString(), end: end.toISOString(), timeZone };
}

// The recording the API sends (base64) as something an audio element can play.
export function audioBlob(base64: string, contentType: string): Blob {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);

    return new Blob([bytes], { type: contentType });
}
